<div
  class="gd-form-toggle-icon-v2"
  [class.gd-form-toggle-icon-v2-checked]="value">

  <!-- Input data -->
  <mat-button-toggle
    [checked]="value"
    [disabled]="disabled"
    (change)="value = !value">

    <!-- Icon -->
    <mat-icon
      class="gd-form-toggle-icon-v2-icon">{{icon}}</mat-icon>

  </mat-button-toggle>

</div>
